<template>
  <div class="pa-5">
    <!--タイトル-->
    <span class="subHead">
      {{ title }}
    </span>
    <v-row>
      <v-col
      cols="12"
      v-for="(item, i) in announcing"
      :key="i">
        <v-card
        height="100%"
        elevation="6"
        class="pa-2">
          <!--演題-->
          <v-card-title
          id="announceTitle">
            {{ item.title }}
          </v-card-title>
          <!--会の名前-->
          <v-list>
            <v-list-item id="announceLocation">
              <v-list-item-icon class="mr-3">
              <v-icon color="indigo">
                {{ item.icon }}
              </v-icon>
            </v-list-item-icon>
              {{ item.location }}
            </v-list-item>
          </v-list>
          <v-divider />
          <!--日時・場所・筆頭演者-->
          <v-list>
            <v-list-item>
              <v-row justify="left">
              <v-col cols="12" xs="12" md="3" lg="3" xl="3"
              v-for="(list, i) in item.lists"
              :key="i"
              class="mx-2">
                <v-list-item-subtitle>
                {{ list.title }}
                <v-list-item-icon>
                  <v-icon class="mt-1">
                    {{ list.icon }}
                  </v-icon>
                </v-list-item-icon>
                </v-list-item-subtitle>
                <v-list-item-title v-text="list.content">
                </v-list-item-title>
                <a :href="list.url">
                {{ list.urltitle }}
                </a>
              </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<style>
#announceTitle {
  background-color: #000066;
  color: white;
}
#announceLocation {
  font-size: 19px;
}
.v-list-item__title {
  white-space: normal !important;
}

</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: '学会発表',
      // 発表内容
      announcing: [
        {
          title: '小惑星探査画像データの閲覧・検索システムJADE: JAXA Asteroid Data Explorer',
          icon: 'mdi-bank',
          location: '2021年度宇宙科学情報解析シンポジウム',
          lists: [
            {
              icon: 'mdi-calendar',
              title: '日時',
              content: '2022年2月18日'
            },
            {
              icon: 'mdi-map-marker',
              title: '場所',
              content: 'オンライン開催'
            },
            {
              icon: 'mdi-account',
              title: '共著者',
              content: '小西健史'
            }
          ]
        },
        {
          title: 'GPUを活用した改良型 RBF ネットワークによる臓器領域描出の高速化',
          icon: 'mdi-bank',
          location: '第42回中国四国医療情報学研究会',
          lists: [
            {
              icon: 'mdi-calendar',
              title: '日時',
              content: '2019年3月'
            },
            {
              icon: 'mdi-map-marker',
              title: '場所',
              content: 'かんぽの宿'
            },
            {
              icon: 'mdi-account',
              title: '筆頭演者',
              content: '小西健史'
            }
          ]
        },
        {
          title: '人工ニューラルネットワークの高速化と医用画像診断への応用',
          icon: 'mdi-bank',
          location: '第35回中国四国医療情報学研究会',
          lists: [
            {
              icon: 'mdi-calendar',
              title: '日時',
              content: '2015年9月4日'
            },
            {
              icon: 'mdi-map-marker',
              title: '場所',
              content: '国民休暇村 蒜山'
            },
            {
              icon: 'mdi-account',
              title: '筆頭演者',
              content: '小西健史'
            }
          ]
        },
        {
          title: '人工ニューラルネットワークの高速化と医用画像診断への応用',
          icon: 'mdi-bank',
          location: '第33回中国四国医療情報学研究会',
          lists: [
            {
              icon: 'mdi-calendar',
              title: '日時',
              content: '2014年9月5日'
            },
            {
              icon: 'mdi-map-marker',
              title: '場所',
              content: '国民休暇村 蒜山'
            },
            {
              icon: 'mdi-account',
              title: '筆頭演者',
              content: '小西健史'
            }
          ]
        },
        {
          title: '国連アジア太平洋統計研修所(SIAP)との連携による各国の統計職員向けe-Learningシステムの開発と評価',
          icon: 'mdi-bank',
          location: '第33回 医療情報学連合大会',
          lists: [
            {
              icon: 'mdi-calendar',
              title: '日時',
              content: '2013年11月21日'
            },
            {
              icon: 'mdi-map-marker',
              title: '場所',
              content: '神戸ファッションマート'
            },
            {
              icon: 'mdi-account',
              title: '筆頭演者',
              content: '小西健史'
            }
          ]
        },
        {
          title: 'Development and Evaluation of Web-based Learning Management System with UN SIAP for government statisticians in Asia and the Pacific',
          icon: 'mdi-bank',
          location: 'E-Learn 2013',
          lists: [
            {
              icon: 'mdi-calendar',
              title: '日時',
              content: '2013年10月24日'
            },
            {
              icon: 'mdi-map-marker',
              title: '場所',
              content: 'Paris Las Vegas'
            },
            {
              icon: 'mdi-account',
              title: '筆頭演者',
              content: '小西健史'
            }
          ]
        },
        {
          title: '衛星「きずな」(WINDS)を用いた衛星回線の医療分野における通信システムとしての評価',
          icon: 'mdi-bank',
          location: '第32回医療情報学連合大会',
          lists: [
            {
              icon: 'mdi-calendar',
              title: '日時',
              content: '2012年10月16日'
            },
            {
              icon: 'mdi-map-marker',
              title: '場所',
              content: '朱鷺メッセ/新潟コンベンションセンター'
            },
            {
              icon: 'mdi-account',
              title: '筆頭演者',
              content: '小西健史'
            }
          ]
        },
        {
          title: 'Evaluation of Multimedia Protocol for Distance Medical Education using the Wideband InterNetworking Satellite',
          icon: 'mdi-bank',
          location: 'E-Learn 2012',
          lists: [
            {
              icon: 'mdi-calendar',
              title: '日時',
              content: '2012年10月9日'
            },
            {
              icon: 'mdi-map-marker',
              title: '場所',
              content: 'Le Centre Sheraton Montreal'
            },
            {
              icon: 'mdi-account',
              title: '筆頭演者',
              content: '小西健史'
            }
          ]
        },
        {
          title: '遠隔教育・医療のための通信基盤技術の評価',
          icon: 'mdi-bank',
          location: '第28回中国四国医療情報学研究会',
          lists: [
            {
              icon: 'mdi-calendar',
              title: '日時',
              content: '2012年3月23日'
            },
            {
              icon: 'mdi-map-marker',
              title: '場所',
              content: '花樹海別館 トレスタ白山'
            },
            {
              icon: 'mdi-account',
              title: '筆頭演者',
              content: '小西健史'
            }
          ]
        },
        {
          title: 'WINDS utilization experiment in the medical field',
          icon: 'mdi-bank',
          location: '第7回WINDS利用実験実施協議会会合',
          lists: [
            {
              icon: 'mdi-calendar',
              title: '日時',
              content: '2012年2月2日'
            },
            {
              icon: 'mdi-map-marker',
              title: '場所',
              content: '日土地ビル'
            },
            {
              icon: 'mdi-account',
              title: '筆頭演者',
              content: '小西健史'
            }
          ]
        },
        {
          title: '高機能なe-Learningシステム',
          icon: 'mdi-bank',
          location: '第25回中国四国医療情報研究会',
          lists: [
            {
              icon: 'mdi-calendar',
              title: '日時',
              content: '2010年9月4日'
            },
            {
              icon: 'mdi-map-marker',
              title: '場所',
              content: '国民休暇村 蒜山'
            },
            {
              icon: 'mdi-account',
              title: '筆頭演者',
              content: '小西健史'
            }
          ]
        }
      ]
    }
  }
}
</script>
